<template>
  <div class="fwdakalist">
    <div class="list">
      <div v-if="type != 1">
        <house-item
        v-for="(house, index) in list"
        :key="index"
        :house="house"
        :type="$route.query.type"
        @handleHosue="handleHosue"
      ></house-item>
      </div>
      <div v-else>
        <houseItemNew
        v-for="(house, index) in list"
        :key="index"
        :house="house"
        :type="$route.query.type"
        @handleHosue="handleHosue"
      ></houseItemNew>
      </div>

      <div class="next" @click="nextPage" v-if="hasMore">下一页</div>
    </div>
    <div class="list-null" v-if="list.length == 0">暂无数据</div>
  </div>
</template>

<script>
import actions from "../../common/actions.js";
import util from "../../common/util.js";
import houseItem from "./fwdakahouse.vue";
import houseItemNew from "./fwdakahousenew.vue";
import gps from "../../common/gps.js";

export default {
  components: { houseItem,houseItemNew },
  data() {
    return {
      list: [],
      hasMore: false,
      page: 0,
      type:null
    };
  },
  created() {
    this.$store.commit("changeTitle", "附近的房源");
    this.getList(1);
  },
  updated() {},
  computed: {},
  watch: {},
  methods: {
    getList(page) {
      if (page == this.page && page != 1) return;
      this.type = this.$route.query.type
      let data = {
        page_size: 20,
        page_number: page,
        type: this.$route.query.type,
        is_system: "no",
        round: 5,
      };
      if (
        this.$route.query.lng == undefined ||
        this.$route.query.lat == undefined
      ) {
        var u = navigator.userAgent;
       var isHuaWei = ( u.indexOf("Android") > -1 && u.indexOf("11") > -1) && u.indexOf("HUAIWEI") > -1 ; //android终端
        if (isHuaWei) {
          util.getLocation().then((res) => {
            alert("百度x:" + res.lng);
            alert("百度y:" + res.lat);
            data.x_count = res.lng;
            data.y_count = res.lat;
            actions.getHouseListByLoc(data).then((res) => {
              if (res.is_success == 0) {
                this.list =
                  page == 1 ? res.content : this.list.concat(res.content);
                this.hasMore = 20 <= parseFloat(res.all_count);
                this.page = page;
              }
            });
          });
        } else {
          util.getLocation().then((res) => {
            // alert("x:" + res.lng);
            // alert("y:" + res.lat);
            // res = { lng: 116.1196460949, lat: 39.9375058141 };
            // res = { lng: 116.131492, lat: 39.910507 };
            // alert('定位')
            alert("x:" + res.lng +';'+"y:" + res.lat+';'+'百度定位成功');
            data.x_count = res.lng;
            data.y_count = res.lat;
            if(data.type == '1'){
              actions.getHouseListByLocNew(data).then((res) => {
              if (res.is_success == 0) {
                this.list =
                  page == 1 ? res.content : this.list.concat(res.content);
                this.hasMore = 20 <= parseFloat(res.all_count);
                this.page = page;
              }
            });
            }else{
              actions.getHouseListByLoc(data).then((res) => {
              if (res.is_success == 0) {
                this.list =
                  page == 1 ? res.content : this.list.concat(res.content);
                this.hasMore = 20 <= parseFloat(res.all_count);
                this.page = page;
              }
            });
            }

          });
        }
      } else {
        data.x_count = this.$route.query.lng;
        data.y_count = this.$route.query.lat;

        actions.getHouseListByLoc(data).then((res) => {
          if (res.is_success == 0) {
            this.list = page == 1 ? res.content : this.list.concat(res.content);
            this.hasMore = 20 <= parseFloat(res.all_count);
            this.page = page;
          }
        });
      }
    },
    nextPage() {
      this.hasMore = false;
      this.getList(this.page + 1);
    },
    handleHosue(type, item) {
      if (type == "daka") {
        actions
          .renWuFangDaKa({
            rwid: this.$route.query.id,
            fangwu_id: item.id,
            qrsj: "",
            qrr: "",
          })
          .then((res) => {
            if (res.is_success == 0) {
              util.showToast("打卡成功");
              this.$router.push({ name: "renwulist" });
            }
          });
      }
    },
  },
};
</script>

<style lang="scss">
.fwdakalist {
  font-size: 0.3rem;
  color: #333;
  .list {
    padding: 0 0.3rem;
    background-color: #fff;
    .next {
      display: flex;
      align-items: center;
      justify-content: center;
      height: 0.9rem;
      margin: 0.3rem 0.1rem 0;
      color: #00ae66;
      border: 1px solid #00ae66;
      background-color: #fff;
    }
  }
  .list-null {
    padding: 0.6rem 0 0;
    text-align: center;
    font-size: 0.3rem;
    color: #666;
  }
}
</style>
